var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23 3H9C5.69 3 3 5.69 3 9v14c0 3.31 2.69 6 6 6h14c3.31 0 6-2.69 6-6V9c0-3.31-2.69-6-6-6zm-.29 18.29c.39.39.39 1.03 0 1.42-.2.19-.45.29-.71.29s-.51-.1-.71-.29L16 17.42l-5.29 5.29c-.2.19-.45.29-.71.29s-.51-.1-.71-.29c-.39-.39-.39-1.03 0-1.42L14.58 16l-5.29-5.29c-.39-.39-.39-1.03 0-1.42s1.03-.39 1.42 0L16 14.58l5.29-5.29c.39-.39 1.03-.39 1.42 0s.39 1.03 0 1.42L17.42 16z",
    fill: "#160647",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.70dd9e871874cb48190d832458d9b2e0.svg";
export { ForwardRef as ReactComponent };